import * as yup from 'yup';

export const bankValidationSchema = yup
    .object()
    .shape({
        bankName: yup.string().required('Please enter Bank Name'),
        bankBranch: yup.string().required('Please enter Bank Branch'),
        accountNo: yup.string().required('Please enter Account No.'),
        ifscCode: yup.string().required('Please enter IFSC Code'),
    }) 